export default {
  headerContent: {
    title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası planları, hem yurt içine hem de yurt dışına yapılacak seyahatlere karşı güvence sunar.',
        'Seyahat sağlık sigortası, kapsamlı bir plan ve belirli bir seyahat sağlık planı ile bağlantılı olarak sunulanlar arasında çok benzer olabilir, ancak primler tıbbi seyahat planları ve kapsamlı planlar arasında farklılık gösterecektir. Her tür seyahat sigortasının avantajları vardır, ancak bir seyahat planlarken doğru planı bulmak önceliğiniz olmalıdır. ',
        'Ne kadar korumaya ihtiyacınız olacağını belirlerken planların içerdiği teminatları göz önünde bulundurmayı unutmayınız.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Planları Nelerdir?',
      content: [
        {
          paragraph:
            'Mapfre güvencesinde sunulan seyahat sağlık sigortası planları:',
          subList: [
            'Keyif Yurt Dışı Seyahat Sağlık Sigortası',
            'Vize Yurt Dışı Seyahat Sağlık Sigortası',
            'Yurt İçi Seyahat Sağlık Sigortası',
            'Yurt Dışı Eğitim Sağlık Sigortası'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
